import { InlineText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

import { Link } from '../../../Link';
import { IStatsGenplanHouse } from '../../../../types/newbuilding/genplan/StatsGenplanHouse';

interface IHouseStatsProps extends IStatsGenplanHouse {
  houseId: number;
  onLinkClick(houseId: number, rooms?: string): void;
}

export function HouseStats({
  houseId,
  fromDeveloperPropsCountUrl,
  fromDeveloperPropsCountDisplay,
  fromDeveloperRooms,
  onLinkClick,
}: IHouseStatsProps) {
  return (
    <>
      {fromDeveloperRooms.map(({ roomTypeDisplay, price2From, offersUrl, roomType }) => (
        <div key={roomTypeDisplay} className={styles['link']}>
          <Link key={roomTypeDisplay} url={offersUrl} target="_blank" onClick={() => onLinkClick(houseId, roomType)}>
            <InlineText2>
              <b>{roomTypeDisplay}</b> {price2From}
            </InlineText2>
          </Link>
        </div>
      ))}
      <div className={styles['link']}>
        <Link url={fromDeveloperPropsCountUrl} target="_blank" onClick={() => onLinkClick(houseId)}>
          <InlineText2 color="text-main-default">{fromDeveloperPropsCountDisplay}</InlineText2>
        </Link>
      </div>
    </>
  );
}
